import moment from 'moment';

/**
 *  A class to construct the onboarding form data
 *  into the required data structure needed by the backend
 */

export default class OnboardingDataBuilder {
  constructor(data) {
    this.userInfo = data;
    const { groupSize, interestedRegions } = this.userInfo;

    this.sendObject = { groupSize, interestedRegions };
  }

  travelStyle() {
    const { duration, month, dateRange, selectedDateCondition } = this.userInfo;

    if (selectedDateCondition === 'datePickr') {
      const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
      const endDate = moment(dateRange[1]).format('YYYY-MM-DD');

      this.addToSendObject({ startDate, endDate });
    }

    if (selectedDateCondition === 'monthPickrAndApproxDuration') {
      this.addToSendObject({
        month: moment(Date.parse(month)).format('YYYY-MM'),
        duration,
      });
    }

    if (selectedDateCondition === 'approxDuration') {
      this.addToSendObject({ duration });
    }

    return this;
  }

  travelDetail() {
    const { trekType, services } = this.userInfo;
    const userChoosedServices = trekType === 'independentTrek';

    if (userChoosedServices) {
      this.addToSendObject({ services, trekType });
    } else {
      this.addToSendObject({ trekType });
    }

    return this;
  }

  addToSendObject(newValues) {
    this.sendObject = { ...this.sendObject, ...newValues };
  }

  build() {
    return this.sendObject;
  }
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/OnboardingDataBuilder.js